module.exports = __webpack_public_path__ + "svg/folded-up-jacket.2da85a39e1b74568d41d908cd8519431.svg";